import { Directive, ElementRef, Renderer2, Input, OnInit, HostListener } from '@angular/core';

import { TooltipManagerService } from 'sharedFeatures/sharedServices';

import { TooltipType } from '../../sharedFeatures/directives/enums/tooltip-type';

import { Utils } from "sharedFeatures/utils";

@Directive({ selector: '[tooltip]' })
export class TooltipDirective {

    @Input('tooltip')
    public text: string = '';

    @Input()
    private calcText: Function | undefined;

    @Input('tooltipTitle')
    private tooltipTitle: string = '';

    @Input('hideAfter')
    private hideAfter: boolean = false;

    @Input('tooltipType')
    private type: string = TooltipType.DEFAULT;


    @Input()
    private pointForShow: Function = this.pointForShowDefault;

    private static disabled: boolean = false;

    private overListener: Function | undefined;
    private leaveListener: Function | undefined;

    private startTime: number | undefined;

    private timeout: number = 0;
    private overEvent: MouseEvent | undefined;


    constructor(private el: ElementRef,
                private r: Renderer2,
                private tlService: TooltipManagerService
    ) {


    }



    @HostListener('mouseenter', ['$event'])
    onEnter(ev: MouseEvent): void {


        this.tlService.reset();
        this.tlService.setActive();



        if (this.timeout) window.clearTimeout(this.timeout);


        let isComponentRowType: boolean = (this.type == TooltipType.COMPONENT_ROW);
        let isContentEmpty: boolean = isComponentRowType ? (Utils.isEmpty(this.text) && Utils.isEmpty(this.tooltipTitle)) : Utils.isEmpty(this.text);


        if (this.calcText) this.text = this.calcText();

        isContentEmpty = isComponentRowType ? (Utils.isEmpty(this.text) && Utils.isEmpty(this.tooltipTitle)) : Utils.isEmpty(this.text);

        if (TooltipDirective.disabled || isContentEmpty) return;

        this.overListener = this.r.listen(this.el.nativeElement, 'mouseover', this.onOver.bind(this));
        this.leaveListener = this.r.listen(this.el.nativeElement, 'mouseleave', this.onLeave.bind(this));


        this.startTime = new Date().getTime();

        this.overEvent = ev;
        this.timeout = window.setTimeout(this.onOver.bind(this), 300);

        this.tlService.setActive(this);

    }

    private onOver(ev: MouseEvent): void {

        if (!ev && this.overEvent)
            ev = this.overEvent;

        let isComponentRowType: boolean = (this.type == TooltipType.COMPONENT_ROW);
        let isContentEmpty: boolean = isComponentRowType ? (Utils.isEmpty(this.text) && Utils.isEmpty(this.tooltipTitle)) : Utils.isEmpty(this.text);

        if (this.calcText) this.text = this.calcText();

        isContentEmpty = isComponentRowType ? (Utils.isEmpty(this.text) && Utils.isEmpty(this.tooltipTitle)) : Utils.isEmpty(this.text);

        if (TooltipDirective.disabled || isContentEmpty) return;

        let time = new Date().getTime();

        if (this.startTime && (time - this.startTime >= 300)) {

            if (Utils.getButtons(ev) != 0) { this.tlService.reset(); return; }

            let point = this.pointForShow(ev, this.tlService.getTooltipSize(this.text, this.tooltipTitle));


            if (!this.tlService.isWasShown()) {

                this.tlService.setWasShown(true);
                this.tlService.showForPoint(this.text, point.x, point.y, this.tooltipTitle, this.type, this.hideAfter);

            }

            this.tlService.moveAt(point.x, point.y);

        }

        if (ev) this.overEvent = ev;

        ev.stopPropagation();

    }

    private onLeave(): void {

        if (TooltipDirective.disabled) return;

        this.tlService.reset();
        this.tlService.setActive();

        this.startTime = undefined;

        if (this.overListener) this.overListener();
        if (this.leaveListener) this.leaveListener();

        if (this.timeout) window.clearTimeout(this.timeout);

        this.overListener = undefined;
        this.leaveListener = undefined;

    }

    public deactivate() {

        if (this.timeout) window.clearTimeout(this.timeout);

    }


    private pointForShowDefault(ev: MouseEvent): any {

        return { x: ev.pageX + 10, y: ev.pageY + 10 };

    }

    public static disable(): void {

        this.disabled = true;

    }

    public static enable(): void {

        this.disabled = false;

    }

    ngOnDestroy(): void {

        this.onLeave();

    }

}
